import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './HelpButton.css';

interface Props {
  onOpenWizard: (step: number) => void;
}

export default function HelpButton({ onOpenWizard }: Props) {
  const { t } = useTranslation('common');
  const { user } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  // On the live map page, the status bar + device info panel stack up above
  // the navbar and would otherwise sit under the fixed help button.
  const isLiveMapPage = location.pathname === '/';

  const lang = user.preferred_language || 'pl';

  const items = [
    // {
    //   icon: '📖',
    //   label: lang === 'pl' ? 'Instrukcja obsługi' : 'User manual',
    //   action: () => { window.open(lang === 'pl' ? '/docs/instrukcja_pl.pdf' : '/docs/instruction_en.pdf', '_blank', 'noopener'); setOpen(false); },
    // },
    {
      icon: '🔔',
      label: lang === 'pl' ? 'Konfiguracja alertów' : 'Alert settings',
      action: () => { onOpenWizard(3); setOpen(false); },
    },
    {
      icon: '📡',
      label: lang === 'pl' ? 'Sprawdź połączenie' : 'Check connection',
      action: () => { onOpenWizard(2); setOpen(false); },
    },
    {
      icon: '🔵',
      label: 'EYE Beacon',
      action: () => { window.open('/docs/instrukcja_pl.pdf', '_blank', 'noopener'); setOpen(false); },
    },
    {
      icon: '✉️',
      label: lang === 'pl' ? 'Kontakt' : 'Contact',
      action: () => { window.location.href = 'mailto:support@10drive.com'; setOpen(false); },
    },
  ];

  return (
    <>
      <button
        className={`help-fab ${isLiveMapPage ? 'help-fab--raised' : ''}`}
        onClick={() => setOpen(true)}
        aria-label="Pomoc"
      >
        ?
      </button>

      {open && (
        <>
          <div className="help-backdrop" onClick={() => setOpen(false)} />
          <div className="help-sheet">
            <div className="help-sheet-header">
              <span className="help-sheet-title">Pomoc</span>
              <button className="help-sheet-close" onClick={() => setOpen(false)}>
                <X size={20} />
              </button>
            </div>
            <ul className="help-sheet-list">
              {items.map((item) => (
                <li key={item.label}>
                  <button className="help-sheet-item" onClick={item.action}>
                    <span className="help-item-icon">{item.icon}</span>
                    <span>{item.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
}
